var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',[_c('v-row',_vm._l((_vm.bars),function(bar){return _c('v-col',{key:bar.name,attrs:{"cols":"12"}},[_c('BarItem',{attrs:{"bar":bar,"val":_vm.axis_result}})],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }